import { createActionTypes } from "../../helpers/utils/createActionTypes"

export const USER = {
    GET_LISTA_USER: createActionTypes("GET_LISTA_USER"),
    GET_DROPDOWN_USER: createActionTypes("GET_DROPDOWN_USER"),
    GET_USER: createActionTypes("GET_USER"),
    SAVE_USER: createActionTypes("SAVE_USER"),

    LOAD_EMPTY_USER: "LOAD_EMPTY_USER",
    CLEAN_MESSAGE_USER: "CLEAN_MESSAGE_USER",
    CHANGE_PAGE_SIZE_USER: "CHANGE_PAGE_SIZE_USER"
}